// extracted by mini-css-extract-plugin
export default {"card":"event_card_card__3+KJM","header":"event_card_header__3T9ir","body":"event_card_body__BVbqf","cardphone":"event_card_cardphone__qWQti"};